import React, { useState, useEffect } from "react";

// import "babel-polyfill";
import { Link } from "@reach/router";
import useGame from "../../hooks/useGame";
import styled from "styled-components";
import {
  TopicsContainer,
  LevelListContainer,
  GameSelectionContainer
} from "../../styled_components/containers";
import {
  Button,
  GreenButton,
  GreyedButton
} from "../../../../globals/components/button";
import Checkbox from "../../../../globals/components/Checkbox";
import Checkbox2 from "../../../../globals/components/Checkbox2";
import { Loading } from "../../../../globals/components/loading";
import KS1 from "../../applications/KS1/Practice";
import { navigate } from "@reach/router";//this is for the back button

import ReactTooltip from 'react-tooltip';
import { debug } from "util";
import { Scale } from 'react-scaling';

function HardCodedTimesTables(){
  var tops = [];
  for (let i = 1; i < 6; i++) {
    var obj = {'name': "Round " + i, 'value': i };
    tops.push(obj);
  }
  return tops;
}

export default function MTCPractice({ id, ...props }) {
  const game = useGame(id);
  const [selectedLevel, setSelectedLevel] = useState([]);
  const [selectedLevelID, setSelectedLevelID] = useState(1);
  const [gameStatus, setGameStatus] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedTopics, setSelectedTopics] = useState([]);
  const[customTimer,setCustomTimer] = useState(10);
  const [accessability, setaccess] = useState("");
  const [setup, setSetup] = useState(false);

  const levels = [1, 2, 3, 4, 5];
  var topics = HardCodedTimesTables();


  function onTopicsSelect(id) {
    setSelectedTopics([...selectedTopics, id]);
    console.log(selectedTopics);
  }

  function onTopicsUnselect(id) {
    setSelectedTopics(
      selectedTopics.filter(function (value) {
        return value !== id;
      })
    );
    setSelectAll(false);
  }

  function launchGame() {
    setGameStatus(true);
  }

  function changeCustomTimer(secondsChange)
  {
    if((secondsChange > 0 && customTimer < 25) || (secondsChange < 0 && customTimer > 5))
    setCustomTimer(customTimer + secondsChange);
  }

  function endGame() {
    console.log("endgame");
    setGameStatus(false);
    props.onEnd && props.onEnd();
  }

  function SelectAll(){
    var tempArray = [];
    for (let i = 0; i < topics.length; i++) {
      tempArray.push(topics[i].value);
    }
    setSelectedTopics(tempArray);
    setSelectAll(true);
    console.log(selectedTopics);
  }

  function UnSelectAll(){
    setSelectAll(false);
    setSelectedTopics([]);
    console.log(selectedTopics);
  }

  function PauseBetween(){
    setaccess("access");
  }

  function UnPauseBetween(){
    setaccess("");
  }

  function GoBack(){
    if (props.eventscreen == undefined){
      navigate("/games/39")
    }else{
      navigate("/war")
    }
    
  }

  if (props.ratingmode == true){
    if (setup == false){
      console.log("rating mode is true");
      topics = HardCodedTimesTables();
      //selectedTopics = HardCodedTimesTables();
      SelectAll();
      launchGame();
      setSetup(true);
    }
  }

  return <div>
        <>
      {gameStatus? (
        <KS1 gameData={game}topics={selectedTopics}timer={customTimer}access={accessability} ratingMode={props.ratingmode} eventscreen={props.eventscreen}></KS1>
      ) : (
          <TopicsContainer lv={selectedLevel}>
            {selectedLevel != undefined ? (

              <Scale scaleTo={1720}>
                <div>
                  <GameSelectionContainer>
                  <Button
                      style={{width: "25%"}}
                        onClick={() => GoBack()}
                      >
                        Back
                    </Button>
                    <h1>Select Years to Practise</h1>
                      <Checkbox
                        label="Select All"
                        bold={true}
                        onChange={e => {
                          if (e.target.checked === true) {
                            SelectAll();
                          } else {
                            UnSelectAll();
                          }
                        }}
                        checked={selectAll}
                      />
                    {topics.map(topic => {
                        return (
                          <Checkbox
                            label={topic.name}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(topic.value);
                              } else {
                                onTopicsUnselect(topic.value);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === topic.value) !== -1 || selectAll
                                ? true
                                : false
                            }
                          />
                        );
                      })}
                  </GameSelectionContainer>

                  <div>
                    {selectedTopics.length > 0 ? (
                      <GreenButton
                        style={{ width: "20%" }}
                        onClick={() => launchGame()}
                      >
                        Play
                                </GreenButton>
                    ) : (
                        <GreyedButton data-tip="You need to add a topic to practice" style={{ width: "20%" }}>Play</GreyedButton>
                      )}
                  </div>
                   <div>
                    <LevelButton
                        style={{ width: "5%" }}
                        onClick={() => changeCustomTimer(1)}
                      >
                        +
                    </LevelButton>

                    <h2 style={{fontSize: "2.5em", color:"#543171FF"}}>{customTimer} total questions</h2>

                    <LevelButton
                        style={{ width: "5%" }}
                        onClick={() => changeCustomTimer(-1)}
                      >
                        -
                    </LevelButton>
                  </div>
                  <br/>
                </div>
              </Scale>
            ) : (
                <div></div>
              )}
          </TopicsContainer>
        )}
    </>
  </div>
}

const Tools = styled(ReactTooltip)`
  font-size: 20px !important;
  background-color: #543171FF !important;
  `

const LevelButton = styled(Button)`
    text-align: center;
    width: 10%;
    height: 70px;
    margin: 5px;
    color: #fff;
    user-select: none;
    background: ${props => (props.active ? "#673b8b," : "rgb(234, 146, 19)")};
    background: ${props =>
    props.active
      ? "linear-gradient(0deg, #673b8b, #683d8c)"
      : "linear-gradient(0deg,rgba(234, 146, 19, 1) 0%,rgba(255, 186, 32, 1) 100%)"};
    border: 2px solid ${props => (props.active ? "#673b8b" : "#e88f12")};

    padding: 0.5em;
    box-sizing: border-box;
    border-radius: 0.25em;
    font-size: 3em;
    cursor: ${props => (props.active ? "pointer" : "")};
    @media (min-width: 1025px) and (max-width: 1440px) {
        font-size: 2.5em;
    }

    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
        margin-bottom: 0;
    }
`;
